import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import LiveLayout from "../components/livelayout"
import SEO from "../components/seo"
import SNGabout from "../components/sngabout"
import SNGlisting from "../components/listing"
import headerImage from '../images/deloitteLandingHeader3.png'
import "../style/main.scss"

const pageNavigation = {
  type: 'horizontal',
  items: [
    {
      title: 'Webinars',
      url: '/',
    }
  ]
}

const pageHeaderImage = {
  imageUri: headerImage,
  imageMobileUril: headerImage,
  imageAltText: 'Deloitte - Innovation in Federal Health',
}

const eventsData = [
  {
    slug: '10-28/watch/',
    title: 'Building low-code, high-impact business applications with Appian',
    date: 'On-Demand',
    time: '1:00 - 2:00 pm ET',
    linktext: 'Watch Now'

  },
  {
    slug: 'watch',
    title: 'Reimagining the contact center experience with Salesforce',
    date: 'On-Demand',
    time: '1:00 - 2:00 pm ET',
    linktext: 'Watch Now'

  },
  {
    slug: 'leveraging-data-analytics/wrap-up',
    title: 'Powering biomedical data science with AI and the cloud',
    date: 'On-Demand',
    time: '12:00 - 1:00 pm ET',
    linktext: 'Watch Now'

  },
  {
      slug: 'power-of-cloud/wrap-up',
      title: 'Leveraging AWS Cloud to Power Clinical Research',
      date: 'On-Demand',
      time: '12:00 - 1:00 pm ET',
      linktext: 'Watch Now'

  }
  
]

const IndexPage = () => {

  return (
    <LiveLayout
      headerImage={pageHeaderImage}
      navigation={pageNavigation} >
      <SEO title="Deloitte Innovation in Federal Health" />
      
      <SNGabout>
      Join us for a thought-provoking four-part webinar series focused on the federal health sector, 
      about technology, trends and innovations that enable government to deliver on critical missions. 
      During each webinar we’ll discuss a different facet of Innovation with U.S. government leaders 
      and key technology partners.
      </SNGabout>

      <SNGlisting events={eventsData}/>
    </LiveLayout>
  )
}

export default IndexPage